import { useEffect, useState } from "react";
import {
  Box,
  Button,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow
} from "@mui/material";
import AddCategory from "../../../Modals/addCategory";
import SwitchToggle from "../../../components/SwitchToggle";
import { useDeleteBudgeMutation, useLazyGetBudgetCategoryQuery, useUpdateBudgetCategoryMutation } from "../../../services/budgetCategory";
import Pagination from "../../../components/Panigation";
import { showError, showToast } from "../../../constants/toasts";
import DeleteConfirmModal from "../../../Modals/deleteConfirmModal";
import SearchBar from "../../../components/SearchBar";
import AddIcon from '@mui/icons-material/Add';
import { isValidInput } from "../../../utils/validations";
import IfCan from "../../../components/IfCan";
const CategoryList = (props: any) => {
  const [open, setOpen] = useState(false);
  const [editCategoryId, setEditCategoryId] = useState<number | null>(null);
  const { searchItem } = props || '';
  const [getBudgetCategory] = useLazyGetBudgetCategoryQuery();
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState<string>("");
  const [isLoading, setIsLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [data, setData] = useState<any[]>([]);
  const [rows, setRows] = useState<any[]>([]);
  const [totalCount, setTotalCount] = useState<number>(0);
  const totalPages = Math.ceil(totalCount / 10);
  const [deleteOpen, setDeleteOpen] = useState(false);
  const [selectedId, setSelectedId] = useState<number | null>(null);
  const [deleteBudgetCategory] = useDeleteBudgeMutation();
  const [UpdateStatus] = useUpdateBudgetCategoryMutation();
  const onPageChange = (newPage: number) => {
    setPage(newPage);
  };
  const handleCloseModal = () => {
    setOpen(false);
    setEditCategoryId(null);
  };
  const getBudgetCatgeoryList = async () => {
    setIsLoading(true);
    try {
      const response = await getBudgetCategory({
        search: debouncedSearchTerm,
        start: page,
        length: 10
      }).unwrap();

      if (response?.status === 200) {
        setData(response?.data?.response_object)
        setRows(response?.data?.response_object || []);
        setTotalCount(response?.data?.total_records || 0)

      } else {
        setData([]);
        setRows(response?.data?.response_object || []);

        setTotalCount(0);
      }

    } catch (error) {
      console.log(error);
      setData([]);
      setTotalCount(0);
    } finally {
      setIsLoading(false);
    }
  };
  const handleStatusUpdate = async (id: number, status: boolean) => {
    const body = {
      is_active: status,
    };

    try {
      const response = await UpdateStatus({ body, id }).unwrap();
      if (response?.status === 200) {
        showToast(
          `Budget category ${!status ? "deactivated" : "activated"} successfully`
        );
        getBudgetCatgeoryList();
      } else {
      }
    } catch (error: any) {
      showError(error?.data?.message || "");
    }
  };
  const handleDelete = async () => {
    if (!selectedId) return;
    try {
      await deleteBudgetCategory({ id: selectedId }).unwrap();
      showToast("Budget category deleted successfully");
      getBudgetCatgeoryList()
    } catch (e: any) {
      showError(e?.data?.message || "Failed to delete budget category");
    }
    setDeleteOpen(false);
    setSelectedId(null);
  };
  useEffect(() => {
    getBudgetCatgeoryList();
  }, [page, debouncedSearchTerm]);

  const onSuccess = async () => {
    getBudgetCatgeoryList()
    setOpen(false)
  }
  const [searchTerm, setSearchTerm] = useState("");
  return (
    <>
      <div className="table_header">
        <div className="left_s">
          <Box className="search_box">
            <SearchBar
              placeholder="Search..."
              searchTerm={searchTerm}
              setDebouncedSearchTerm={setDebouncedSearchTerm}
              value={searchTerm}
              onCross={() => setSearchTerm("")}
              onChange={(val: any) => {
                if (isValidInput(val.target.value)) {
                  setSearchTerm(val.target.value);
                }
              }}
            />
          </Box>
        </div>
        <div className="right_s">
          <IfCan module="Budget Intelligence" action="add_edit">
            <Button className="btn btn_primary" onClick={() => { setEditCategoryId(null); setOpen(true); }}><AddIcon /> Add Category</Button>
          </IfCan>
        </div>
      </div>
      <TableContainer className="table_container">
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Category Name</TableCell>
              <TableCell>Alert Threshold</TableCell>
              {/* <TableCell>Created Date</TableCell> */}
              <TableCell>Status</TableCell>
              <TableCell>Action</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data.length > 0 ? (

              data.map((row) => (
                <TableRow hover key={row.id}>
                  <TableCell>
                    <div className="user_block">
                      <figure className="no_radius">
                        <img src={row?.icon?.media_file_url || "/static/images/placeholder.png"} alt="Edit" />
                      </figure>
                      <p><b>{row.category_name}</b></p>
                    </div>
                  </TableCell>
                  <TableCell>{row?.threshold}</TableCell>
                  {/* <TableCell>{row?.date}</TableCell> */}
                  <TableCell>
                    <IfCan module="Budget Intelligence" action="add_edit">
                      <SwitchToggle
                        defaultChecked={Boolean(row.is_active)}
                        onChange={(checked) =>
                          handleStatusUpdate(row?.id, checked)
                        }
                      />
                    </IfCan>
                  </TableCell>
                  <TableCell>
                    <Box className="table_actions v2">
                      <IfCan module="Budget Intelligence" action="add_edit">
                        <IconButton onClick={() => { setEditCategoryId(row?.id); setOpen(true); }}>
                          <img src="/static/images/edit2_icon.svg" alt="Edit" />
                        </IconButton>
                      </IfCan>
                      <IfCan module="Budget Intelligence" action="delete">
                        <IconButton onClick={() => { setSelectedId(row.id); setDeleteOpen(true); }}>
                          <img src="/static/images/trash2_icon.svg" alt="Delete" />
                        </IconButton>
                      </IfCan>
                    </Box>
                  </TableCell>
                </TableRow>
              ))

            ) : (
              <TableRow>
                <TableCell colSpan={5} align="center">
                  No Data Found
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
      <Pagination
        module={rows}
        page={page}
        onPageChange={onPageChange}
        totalPages={totalPages}
        totalCount={totalCount}
        setPage={setPage}
      />
      <DeleteConfirmModal
        open={deleteOpen}
        setOpen={setDeleteOpen}
        handleDelete={handleDelete}
        title="Are you sure you want to delete this category?"
        message="This action cannot be undone."
      />
      <AddCategory categoryId={editCategoryId} onSuccess={onSuccess} open={open} onClose={handleCloseModal} setOpen={setOpen} />
    </>
  );
};

export default CategoryList;
